import { TabPane } from 'semantic-ui-react';
import { validationClasses } from './errors';

const updateMultiplePanels = ({ panels }, { panel, index }) => (panels[panel].includes(index)
  ? panels[panel].filter((i) => i !== index)
  : [...panels[panel], index]);

export const updateSingularPanels = ({ panels }, { index }) => (panels.includes(index)
  ? panels.filter((i) => i !== index)
  : [...panels, index]);

const tabTitle = ({ name, isSection }, defaultEntity, sections, intl) => {
  const entity = isSection ? undefined : defaultEntity;
  const title = isSection ? sections[name].label : undefined;
  return entity ? intl.formatMessage({ id: `${entity}.breadcrumb.${name}_title` }) : title;
};

const tabMenu = ({ name, icon, error }, entity, title, onRender) => ({
  menuItem: {
    content: title,
    icon,
    key: `${entity}_tab_${name}`,
    className: validationClasses(error),
  },
  render: () => {
    const { hasPane, content } = onRender(name);
    return hasPane ? <TabPane>{content}</TabPane> : content;
  },
});

export const tabMenus = (defaultEntity, indexes, tabs, sections, onRender, intl) => {
  const items = Object.values(tabs);
  return indexes.map((i) => {
    const title = tabTitle(items[i], defaultEntity, sections, intl);
    return tabMenu(items[i], defaultEntity, title, onRender);
  });
};

export default updateMultiplePanels;
